var map = {
	"./dtmf_0.wav": [
		1401,
		9
	],
	"./dtmf_1.wav": [
		1402,
		10
	],
	"./dtmf_2.wav": [
		1403,
		11
	],
	"./dtmf_3.wav": [
		1404,
		12
	],
	"./dtmf_4.wav": [
		1405,
		13
	],
	"./dtmf_5.wav": [
		1406,
		14
	],
	"./dtmf_6.wav": [
		1407,
		15
	],
	"./dtmf_7.wav": [
		1408,
		16
	],
	"./dtmf_8.wav": [
		1409,
		17
	],
	"./dtmf_9.wav": [
		1410,
		18
	],
	"./dtmf_hash.wav": [
		1400,
		1
	],
	"./dtmf_star.wav": [
		1399,
		2
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 7);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 1245;
module.exports = webpackAsyncContext;